export default {
    render(value: string[]) { 
        return value.slice(0).sort().join(" "); 
    },
    parse(str: string) { 
        return str.split(/\s+/).filter(s => s).sort();
    }
};




// WEBPACK FOOTER //
// ./docs-src/demos/simpsons/tagsAsString.ts